import { getLabelTranslation } from '@/apis/translateApis'
import store from '@/store'
import defaultTagData from '@/util/defaultTagData'

// 默认环境根据本地语言环境 但是本地语言环境有哈萨克语，标签上没有哈萨克语，需要处理, 如果是哈萨克语替换成中文
// 将数据本地的key和接口的key对应一下
export const languageMap = new Map<string, string>([
  ['zh', 'zh'],
  ['zh_hant', 'zh_hant'],
  ['en', 'en'],
  ['kz', 'kz'], // 哈萨克语替换成中文
  ['vi', 'vie'],
  ['id', 'id'],
  ['th', 'th'],
  ['ug', 'ug'],
  ['ru', 'ru'],
  ['ben', 'ben'], // 孟加拉语
  ['kor', 'ko'], // 韩语
  ['bur', 'bur'], // 缅甸语
  ['tr', 'tr'], // 土耳其语
  ['km', 'km'], // 柬埔寨语
  ['es', 'es'], // 西班牙语
  ['ar', 'ar'], // 阿拉伯语
]) as any

/** 一些补充文本，柜柜可能没有的云排版默认标签上的内容 */
export const additionalTranslateMap = new Map<string, Record<string, string>>([
  [
    'zh_hant',
    {
      // 繁体中文
      板件条码: '板件條碼',
      修边值: '修邊值',
      余料条码: '餘料條碼',
      余料库: '餘料庫',
      左开: '左開',
      右开: '右開',
      '微信扫一扫，余料即入库': '微信掃一掃，餘料即入庫',
      请双击输入文本: '請雙擊輸入文本',
      请选择对应数据项: '請選擇對應數據項',
      前: '前',
    },
  ],
  [
    'en',
    {
      // 英语
      板件条码: 'Panel Barcode',
      修边值: 'Trimming Value',
      余料条码: 'Remnant Barcode',
      余料库: 'Remnant Repository',
      左开: 'Left Open',
      右开: 'Right Open',
      '微信扫一扫，余料即入库': 'Scan with WeChat, Remnant Auto-Stocked',
      请双击输入文本: 'Double-click to enter text',
      请选择对应数据项: 'Please select the corresponding data item',
      前: 'Front',
    },
  ],
  [
    'vie',
    {
      // 越南语
      板件条码: 'Mã vạch tấm',
      修边值: 'Giá trị xén',
      余料条码: 'Mã vạch phế liệu',
      余料库: 'Kho phế liệu',
      左开: 'Mở trái',
      右开: 'Mở phải',
      '微信扫一扫，余料即入库': 'Quét bằng WeChat, tự động nhập kho phế liệu',
      请双击输入文本: 'Nhấp đúp để nhập văn bản',
      请选择对应数据项: 'Vui lòng chọn mục dữ liệu tương ứng',
      前: 'Trước ',
    },
  ],
  [
    'id',
    {
      // 印尼语
      板件条码: 'Kode Batang Panel',
      修边值: 'Nilai Pemangkasan',
      余料条码: 'Kode Batang Sisa',
      余料库: 'Gudang Sisa',
      左开: 'Buka Kiri',
      右开: 'Buka Kanan',
      '微信扫一扫，余料即入库':
        'Scan dengan WeChat, sisa otomatis masuk gudang',
      请双击输入文本: 'Klik dua kali untuk memasukkan teks',
      请选择对应数据项: 'Silakan pilih item data yang sesuai',
      前: 'Depan',
    },
  ],
  [
    'th',
    {
      // 泰语
      板件条码: 'บาร์โค้ดแผ่น',
      修边值: 'ค่าตกแต่ง',
      余料条码: 'บาร์โค้ดเศษวัสดุ',
      余料库: 'คลังเศษวัสดุ',
      左开: 'เปิดซ้าย',
      右开: 'เปิดขวา',
      '微信扫一扫，余料即入库': 'สแกนด้วย WeChat เศษวัสดุเข้าคลังอัตโนมัติ',
      请双击输入文本: 'ดับเบิลคลิกเพื่อป้อนข้อความ',
      请选择对应数据项: 'กรุณาเลือกรายการข้อมูลที่เกี่ยวข้อง',
      前: 'หน้า',
    },
  ],
  [
    'ug',
    {
      // 维吾尔语
      板件条码: 'تاختا باركود',
      修边值: 'چېگرا قىممىتى',
      余料条码: 'قالدۇق ماتېريال باركودى',
      余料库: 'قالدۇق ماتېريال ئامبىرى',
      左开: 'سول ئاچ',
      右开: 'ئوڭ ئاچ',
      '微信扫一扫，余料即入库':
        'WeChat سىكانىرلاش، قالدۇق ماتېريال ئاپتوماتىك ئامبىرى',
      请双击输入文本: 'تېكىست كىرگۈزۈش ئۈچۈن قوش چېكىڭ',
      请选择对应数据项: 'ئالاقىدار سانلىق مەلۇمات تاللاڭ',
      前: 'ئالدى',
    },
  ],
  [
    'ru',
    {
      // 俄语
      板件条码: 'Штрих-код панели',
      修边值: 'Значение обрезки',
      余料条码: 'Штрих-код остатка',
      余料库: 'Хранилище остатков',
      左开: 'Открыто слева',
      右开: 'Открыто справа',
      '微信扫一扫，余料即入库':
        'Сканируйте WeChat, автоматический учет остатков',
      请双击输入文本: 'Двойной щелчок для ввода текста',
      请选择对应数据项: 'Пожалуйста, выберите соответствующий элемент данных',
      前: 'Передний ',
    },
  ],
  [
    'zh',
    {
      // 中文（占位，已默认返回原文）
      板件条码: '板件条码',
      修边值: '修边值',
      余料条码: '余料条码',
      余料库: '余料库',
      左开: '左开',
      右开: '右开',
      '微信扫一扫，余料即入库': '微信扫一扫，余料即入库',
      请双击输入文本: '请双击输入文本',
      请选择对应数据项: '请选择对应数据项',
      前: '前',
    },
  ],
  [
    'kz',
    {
      // 哈萨克语
      板件条码: 'Панель штрих-код',
      修边值: 'Қырқу мәні',
      余料条码: 'Қалдық штрих-код',
      余料库: 'Қалдық қоймасы',
      左开: 'Сол ашу',
      右开: 'Оң ашу',
      '微信扫一扫，余料即入库':
        'WeChat арқылы сканерлеңіз, қалдық автоматты түрде қоймаға түседі',
      请双击输入文本: 'Мәтін енгізу үшін екі рет басыңыз',
      请选择对应数据项: 'Сәйкес деректер элементін таңдаңыз',
      前: 'Алды',
    },
  ],
  [
    'ko',
    {
      // 韩语
      板件条码: '패널 바코드',
      修边值: '트리밍 값',
      余料条码: '남은 바코드',
      余料库: '남은 창고',
      左开: '왼쪽 열기',
      右开: '오른쪽 열기',
      '微信扫一扫，余料即入库': 'WeChat으로 스캔하면, 남은 자동 입고',
      请双击输入文本: '텍스트를 입력하려면 더블 클릭하세요',
      请选择对应数据项: '해당 데이터 항목을 선택하세요',
      前: '앞',
    },
  ],
  [
    'bur',
    {
      // 缅甸语
      板件条码: 'ဘုတ်ဘားကုဒ်',
      修边值: 'အနားသတ်တန်ဖိုး',
      余料条码: 'အကြွင်းဘားကုဒ်',
      余料库: 'အကြွင်းဂိုဒေါင်',
      左开: 'ဘယ်ဘက်ဖွင့်',
      右开: 'ညာဘက်ဖွင့်',
      '微信扫一扫，余料即入库':
        'WeChat ဖြင့် စကန်ဖတ်ပါ၊ အကြွင်းအလိုအလျောက် သိုလှောင်ပါ',
      请双击输入文本: 'စာသားထည့်သွင်းရန် နှစ်ချက်နှိပ်ပါ',
      请选择对应数据项: 'သက်ဆိုင်ရာဒေတာပစ္စည်းကိုရွေးချယ်ပါ',
      前: 'ရှေ့',
    },
  ],
  [
    'ben',
    {
      // 孟加拉语
      板件条码: 'প্যানেল বারকোড',
      修边值: 'ট্রিমিং মান',
      余料条码: 'অবশিষ্ট বারকোড',
      余料库: 'অবশিষ্ট গুদাম',
      左开: 'বাম খোলা',
      右开: 'ডান খোলা',
      '微信扫一扫，余料即入库':
        'WeChat দিয়ে স্ক্যান করুন, অবশিষ্ট স্বয়ংক্রিয়ভাবে গুদামে',
      请双击输入文本: 'পাঠ লিখতে ডাবল ক্লিক করুন',
      请选择对应数据项: 'সঠিক ডেটা আইটেম নির্বাচন করুন',
      前: 'সামনে',
    },
  ],
  [
    'tr',
    {
      // 土耳其语
      板件条码: 'Panel barkod',
      修边值: 'Kesme değeri',
      余料条码: 'Artık barkod',
      余料库: 'Artık deposu',
      左开: 'Sol açık',
      右开: 'Sağ açık',
      '微信扫一扫，余料即入库':
        'WeChat ile tarayın, artık otomatik depoya girsin',
      请双击输入文本: 'Metin girmek için çift tıklayın',
      请选择对应数据项: 'Lütfen ilgili veri öğesini seçin',
      前: 'Ön',
    },
  ],
  [
    'km',
    {
      // 柬埔寨语
      板件条码: 'បន្ទះបាកូដ',
      修边值: 'តម្លៃកាត់គែម',
      余料条码: 'សំណល់បាកូដ',
      余料库: 'ឃ្លាំងសំណល់',
      左开: 'បើកឆ្វេង',
      右开: 'បើកស្តាំ',
      '微信扫一扫，余料即入库':
        'ស្កែនជាមួយ WeChat សំណល់ចូលឃ្លាំងដោយស្វ័យប្រវត្តិ',
      请双击输入文本: 'ចុចពីរដងដើម្បីបញ្ចូលអត្ថបទ',
      请选择对应数据项: 'សូមជ្រើសរើសធាតុទិន្នន័យដែលត្រូវគ្នា',
      前: 'មុខ',
    },
  ],
  [
    'es',
    {
      // 西班牙语
      板件条码: 'Código de barras de panel',
      修边值: 'Valor de recorte',
      余料条码: 'Código de barras de sobrante',
      余料库: 'Almacén de sobrantes',
      左开: 'Abrir por la izquierda',
      右开: 'Abrir por la derecha',
      '微信扫一扫，余料即入库':
        'Escanee con WeChat, el sobrante se almacena automáticamente',
      请双击输入文本: 'Doble clic para ingresar texto',
      请选择对应数据项: 'Seleccione el elemento de datos correspondiente',
      前: 'Frente',
    },
  ],
  [
    'ar',
    {
      // 阿拉伯语
      板件条码: 'باركود اللوحة',
      修边值: 'قيمة الحواف',
      余料条码: 'باركود الباقي',
      余料库: 'مستودع الباقي',
      左开: 'فتح يسار',
      右开: 'فتح يمين',
      '微信扫一扫，余料即入库':
        'امسح بـ WeChat ، يذهب الباقي إلى المستودع تلقائيًا',
      请双击输入文本: 'انقر نقرًا مزدوجًا لإدخال النص',
      请选择对应数据项: 'يرجى تحديد عنصر البيانات المقابل',
      前: 'امام',
    },
  ],
])

// 缓存已检查的key，避免重复计算
const processedKeyCache = new Map<string, string>()

/**
 * @description 翻译标签上的文本
 *  @params key 文本
 */
export function translateTemplateWay(key: string) {
  // 获取当前的语言设置
  const exportLanguage = getCurrentLanguage()
  // 中文直接返回原始key
  if (exportLanguage === 'zh' || !exportLanguage) return key

  // 检查缓存 避免多次遍历获得的语言数据
  const cacheKey = `${exportLanguage}-${key}`
  if (processedKeyCache.has(cacheKey)) {
    return processedKeyCache.get(cacheKey) as string
  }

  // 获取翻译模板
  const templateMap = store.state?.templateMap || new Map()
  const template = templateMap.get(exportLanguage) as any
  // 完全能匹配上
  if (template?.[key]) {
    processedKeyCache.set(cacheKey, template[key])
    return template[key]
  }

  // 部分匹配（只要能找到key就替换）
  const translatedKey = matchPartialKey(key, template || {})
  processedKeyCache.set(cacheKey, translatedKey)
  return translatedKey
}
function getCurrentLanguage() {
  return languageMap.get(store.state.exportLanguage) || 'zh'
}
// 部分匹配逻辑
function matchPartialKey(key: string, template: Record<string, string>) {
  // 遍历模板，找到部分匹配的键
  const keys = Object.keys(template)
  // 将字符串按照长度排序，避免出现项目地址和项目冲突的问题
  keys.sort((a, b) => b.length - a.length)
  for (const k of keys) {
    if (key.includes(k)) {
      // 替换所有匹配的部分
      key = key.replaceAll(k, template[k])
    }
  }
  return key
}

/**
 * @description 模板中间转译
 * @params template 标签模板
 * @returns 返回中间的转译文本（中文模板）
 */
export async function escapeTemplate(template: { [key: string]: any }) {
  const isNeedParse =
    template.tem_data && template.surplus_data && template.surplus_waste_data
  // 不存在模板再去解析默认模板
  const parsedDefault = isNeedParse ? null : JSON.parse(defaultTagData)
  const {
    tem_data = parsedDefault?.tem_data,
    surplus_data = parsedDefault?.surplus_data,
    surplus_waste_data = parsedDefault?.surplus_waste_data,
  } = template
  const language = getEditEnvironmentLanguage(template)
  // 同步返回点
  if (!language || language === 'zh') {
    return Promise.resolve(template)
  }

  const templateMap = store.state.templateMap ?? new Map()
  if (!templateMap.has(language)) {
    try {
      if (!language) return
      const res = await getLabelTranslation({ language })
      store.commit(
        'setTemplateMap',
        templateMap.set(language, {
          ...res.data,
          ...additionalTranslateMap.get(language),
        })
      )
    } catch (err) {
      console.error('加载翻译失败:', err)
      store.commit(
        'setTemplateMap',
        templateMap.set(language, additionalTranslateMap.get(language))
      )
    }
  }

  // 创建反向语言映射
  const languageCodeMap = templateMap.get(language)

  // 筛选空值处理是为了避免柜柜存在部分翻译数据对应的空内容 比如印尼语的翻译 分类: '' 和锁头设置: ''
  const reversedLanguageMap = new Map(
    Object.entries(languageCodeMap)
      .filter(([_, value]) => value) // 过滤掉空字符串值
      .map(([key, value]) => ({ key: value, value: key }))
      .sort((a, b) => b.value.length - a.value.length)
      .map((item) => [item.key, item.value])
  )

  const processTextReplacements = (dataItem: any) => {
    const data = dataItem.data || {}
    if (data.text && typeof data.text === 'string') {
      let text = data.text
      reversedLanguageMap.forEach((originalKey, translatedKey) => {
        text = text.replaceAll(translatedKey, originalKey)
      })
      data.text = text
    }
  }
  tem_data.forEach(processTextReplacements)
  surplus_data.forEach(processTextReplacements)
  surplus_waste_data.forEach(processTextReplacements)

  return template
}

/** 获取编辑时模板的语言环境 */
export function getEditEnvironmentLanguage(template: { [key: string]: any }) {
  const { tem_data, surplus_data, surplus_waste_data } = template
  const language = tem_data
    .concat(surplus_data)
    .concat(surplus_waste_data)
    .find((item: any) => item?.type == 'FixedText')?.data?.language
  return languageMap.get(language) || 'zh'
}
